import { render, staticRenderFns } from "./CapterraReviewCard.vue?vue&type=template&id=704ac5e3&scoped=true"
import script from "./CapterraReviewCard.vue?vue&type=script&lang=js"
export * from "./CapterraReviewCard.vue?vue&type=script&lang=js"
import style0 from "./CapterraReviewCard.vue?vue&type=style&index=0&id=704ac5e3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ac5e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704ac5e3')) {
      api.createRecord('704ac5e3', component.options)
    } else {
      api.reload('704ac5e3', component.options)
    }
    module.hot.accept("./CapterraReviewCard.vue?vue&type=template&id=704ac5e3&scoped=true", function () {
      api.rerender('704ac5e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/CapterraReviews/CapterraReviewCard.vue"
export default component.exports